import request from '@/router/axios';
export const add = (row) => {
    return request({
        url: '/api/produce/employee-device-rel/insert',
        method: 'post',
        data: row
    })
}
export const update = (row) => {
    return request({
        url: '/api/produce/employee-device-rel/update',
        method: 'post',
        data: row
    })
}
export const getDetail = (id) => {
    return request({
        url: '/api/produce/employee-device-rel/select/id',
        method: 'get',
        params: {
            id
        }
    })
}
export const getList = (params) => {
    return request({
        url: '/api/produce/employee-device-rel/select/page',
        method: 'get',
        params
    })
}
export const remove = (id) => {
    return request({
        url: '/api/produce/employee-device-rel/delete/id',
        method: 'get',
        params: {
            id
        }
    })
}

export const getContractExtpage = (params) => {
    return request({
        url: '/api/produce/transport-contract-ext/select/contractExtpage',
        method: 'get',
        params
    })
}
export const getContractList = (params) => {
    return request({
        url: '/api/produce/transport-contract-ext/select/contractExtpage',
        method: 'get',
        params
    })
}
 
